<template>
  <div class="">
    <div
      v-if="loading"
    >
      <i class="fa fa-spin fa-fw fa-circle-o-notch text-muted"></i>
    </div>
    <div
      v-if="!loading"
    >
      <div
        v-if="error"
      >
        <p>Your account is <b class="text-danger">not connected</b> to DocuSign.</p>
        <a
          :href="authUrl"
          class="btn btn-white"
        >
          Connect DocuSign
        </a>
      </div>
      <div
        v-else
      >
        <p>Your account is <b class="text-success">connected</b> to DocuSign.</p>
        <a
          :href="authUrl"
          class="btn btn-white"
        >
          Refresh Connection
        </a>
      </div>

    </div>
  </div>
</template>

<script>
import { getDocuSignUser } from '@/api'

export default {
  props: {
    userId: {
      type: [String, Number],
      required: true
    },
    authUrl: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: true
    }
  },
  async mounted () {
    try {
      let response = await getDocuSignUser(this.userId)

    } catch (e) {
      this.error = true
    } finally {
      this.loading = false
    }
  }
}
</script>